import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { words } from './model';
export function BadgeSkeleton({ rows }) {
  const { locale } = useWebLocale();
  return (
    <div
      className="pp-badge-skeleton"
      role="status"
      aria-label={words(locale)('common.loading')}
      aria-busy="true"
    >
      {Array.from({ length: rows }, (_, i) => (
        <span key={i} aria-hidden="true" />
      ))}
    </div>
  );
}
export function BadgeError({ onRetry }) {
  const { locale } = useWebLocale(),
    t = words(locale);
  return (
    <div className="pp-badge-error" role="alert">
      <FiAlertCircle size={28} strokeWidth={1.5} aria-hidden="true" />
      <h2>{t('common.errorTitle')}</h2>
      <p>{t('badges.loadError')}</p>
      <button onClick={onRetry}>{t('common.retry')}</button>
    </div>
  );
}
